﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { LanguageService } from '../core/language/language.service';
import { LoginType } from '../core/models/administration/system-parameters/login-type';
import { CONFIG } from '../core/config';
import { SecurityService } from '../core/services/security.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    public showPwd: boolean = false;
    public message: string = '';
    private loginTypes: LoginType[];
    private languageID: number;
    public showRegisteredUser: boolean = false;
    public showAnonymousUser: boolean = false;

    constructor(private _router: Router, private _route: ActivatedRoute,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _languageService: LanguageService) {
        this.loginTypes = [];
        this.languageID = this._languageService.selectedLanguageId;
        const navigation = this._router.getCurrentNavigation();
        const state = navigation.extras.state as { message: string };
        if(state)
            this.message = state.message;
        
    }

    ngOnInit() {
        this._securityService.logout();

        this._sharedService.getAllLoginTypesForDropdown(0, true, this.languageID).subscribe(result => {
            this.loginTypes = result;

            if (this.loginTypes.find(x => x.id == CONFIG.loginTypes.RegisteredUser))
                this.showRegisteredUser = true;
            if (this.loginTypes.find(x => x.id == CONFIG.loginTypes.AnonymousUser))
                this.showAnonymousUser = true;
        });
    }

    showPasswordToggle() {
        this.showPwd = !this.showPwd;
    }    

    redirectToLogin(loginPageToRedirect: string) {
        let params = this._route.snapshot.queryParams;

        if (loginPageToRedirect == 'registered') {
            this._router.navigate(['/login/registered'], { queryParams: { 'redirectURL': params['redirectURL'] } });
        } else if (loginPageToRedirect == 'anonymous') {
            this._router.navigate(['/login/anonymous'], { queryParams: { 'redirectURL': params['redirectURL'] } });
        }
    }
}
